import classNames from 'classnames';
import { useCallback, useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { Footer, TopBar } from '@adviser-group/aberdeen-design-system';

import PageContext from '@/Providers/PageContextProvider/PageContext';
import usePlatform from '@/hooks/use-platform';
import { layoutClassNames } from '@/utils/consts';

import CustomContent from './CustomContent';
import styles from './index.module.scss';

const AppLayout = () => {
  const { isMobile } = usePlatform();
  const { loading } = useContext(PageContext);
  const handleClose = useCallback(() => {
    /* Noop */
  }, []);

  return (
    <>
      {loading && (
        <div className={styles.loading}>
          <div className={styles.spinner} />
        </div>
      )}
      <div className={classNames(styles.viewBox, loading && styles.hidden)}>
        <div className={classNames(styles.fullWidthCustomContainer)}>
          <div className={classNames(styles.topBarContainer)}>
            <TopBar showLogo logoSize={32} onClose={handleClose} />
          </div>
          {!isMobile && <CustomContent className={layoutClassNames.customContent} />}
          <main className={classNames(styles.mainContent)}>
            <Outlet />
          </main>
          <Footer
            showLogo
            backgroundToken="--sc-bg-secondary-hover"
            alignment="left"
            disclaimer={{
              children: 'Copyright © Aberdeen Group plc 2026. All rights reserved.',
              color: 'secondary',
              size: 'small',
              variant: 'body',
            }}
            links={[
              {
                children: 'Accessibility',
                className: 'responsive-text-link-small default',
                href: 'https://www.aberdeenadviser.com/en-gb/accessibility',
                size: 'small',
              },
              {
                children: 'Cookie Policy',
                className: 'responsive-text-link-small default',
                href: 'https://www.aberdeenplc.com/en-gb/cookie-policy',
                size: 'small',
              },
              {
                children: 'Legal information',
                className: 'responsive-text-link-small default',
                href: 'https://www.aberdeenadviser.com/en-gb/legal',
                size: 'small',
              },
              {
                children: 'Modern Slavery Statement',
                className: 'responsive-text-link-small default',
                href: 'https://www.aberdeeninvestments.com/docs?editionId=c073cb0f-135c-4544-a82c-9ca20a7f29e8&_gl=1*3f4r3k*_gcl_au*ODAyNzM4NTAwLjE3NzM3NjYxNDQ.*_ga*Njk5MDg1MzkzLjE3NzM3NjYxNDQ.*_ga_TML7E2DDE5*czE3NzM3NjYxNDQkbzEkZzAkdDE3NzM3NjYxNDckajU3JGwwJGgw',
                size: 'small',
              },
              {
                children: 'Privacy policy',
                className: 'responsive-text-link-small default',
                href: 'https://www.aberdeenadviser.com/en-gb/privacy',
                size: 'small',
              },
            ]}
            logo={{
              variant: 'wordmark',
            }}
            logoHeight={32}
            logoWidth={185}
          />
        </div>
      </div>
    </>
  );
};

export default AppLayout;
